import { OffersAndVouchersSectionTab } from './types';

export const OFFERS_SECTION_TAB_PARAM = 'offers-tab';
export const DEFAULT_OFFERS_SECTION_TAB: OffersAndVouchersSectionTab = 'offers';
export const OFFERS_SECTION_TABS: OffersAndVouchersSectionTab[] = [
  'offers',
  'inProgress',
  'vouchers',
];

export const titleByTab: Record<OffersAndVouchersSectionTab, string> = {
  offers: 'Offers',
  inProgress: 'Progress Offers',
  vouchers: 'Vouchers',
};
